import styled from 'styled-components';
import Input from '../../Input';

export const InputNameDocument = styled(Input).attrs({
  stateName: "nameDocument",
  name: "Nome do documento",
  className: "w-100",
  type: "text",
  placeholder: "Nome do documento"
})``;